import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, propTypes as formPropTypes } from 'redux-form';

import { addDownloadOption, removeDownloadOption, toggleBanner } from './actions';
import { options, showBanner } from './reducer';
import { disabled } from '../components/modal/reducer';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { H2, Checkbox } from '../components';

import { INCLUDE_SIZES, INCLUDE_IMAGES, INCLUDE_UPC, REPORT_TYPE_ORDER } from './constants';

const prefix = 'downloadModal_checkbox';

class DownloadModal extends Component {
  componentDidMount() {
    const { options, change, showBanner, toggleBanner, disabled } = this.props;
    change(`${prefix}_${INCLUDE_SIZES}`, options.filter(option => option === INCLUDE_SIZES).length > 0);
    change(`${prefix}_${INCLUDE_IMAGES}`, options.filter(option => option === INCLUDE_IMAGES).length > 0);
    change(`${prefix}_${INCLUDE_UPC}`, options.filter(option => option === INCLUDE_UPC).length > 0);
    // --
    if (disabled && !showBanner) toggleBanner();
  }

  onFormChange = (value, field) => {
    const { addDownloadOption, removeDownloadOption, type } = this.props;
    if (value) addDownloadOption(field, type);
    else if (!value && field === INCLUDE_SIZES) {
      removeDownloadOption(field, type);
      removeDownloadOption(INCLUDE_IMAGES, type);
    } else removeDownloadOption(field, type);
  };

  handleSizeQuantityChange = e => {
    const { change } = this.props;
    this.onFormChange(e, INCLUDE_SIZES);
    if (!e) change(`${prefix}_${INCLUDE_IMAGES}`, false);
  };

  handleImagesChange = e => {
    const { change } = this.props;
    this.onFormChange(e, INCLUDE_IMAGES);
    if (e) {
      this.onFormChange(e, INCLUDE_SIZES);
      change(`${prefix}_${INCLUDE_SIZES}`, true);
    }
  };

  handleUpcChange = e => {
    this.onFormChange(e, INCLUDE_UPC);
  };

  render() {
    return (
      <div className='downloadModal flex-container column start ta-sm-l text-color-primary-dark'>
        <H2 className='mb0-sm'>
          <TranslatedCopy id='returnDetails.download.options' />
        </H2>
        <ul className='pt4-sm ta-sm-l'>
          <li>
            <Field
              name={`${prefix}_${INCLUDE_SIZES}`}
              type='checkbox'
              component={Checkbox}
              onChange={this.handleSizeQuantityChange}
              label={
                <span>
                  <TranslatedCopy id='returnDetails.modal.sizeQuantity' />
                </span>
              }
            />
          </li>
          <li>
            <Field
              name={`${prefix}_${INCLUDE_IMAGES}`}
              type='checkbox'
              component={Checkbox}
              onChange={this.handleImagesChange}
              label={
                <span>
                  <TranslatedCopy id='returnDetails.modal.images' />
                </span>
              }
            />
          </li>
          <li>
            <Field
              name={`${prefix}_${INCLUDE_UPC}`}
              type='checkbox'
              component={Checkbox}
              onChange={this.handleUpcChange}
              label={
                <span>
                  <TranslatedCopy id='returnDetails.modal.upc' />
                </span>
              }
            />
          </li>
        </ul>
      </div>
    );
  }
}

DownloadModal.propTypes = {
  ...formPropTypes,
  type: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  addDownloadOption: PropTypes.func.isRequired,
  removeDownloadOption: PropTypes.func.isRequired,
  showBanner: PropTypes.bool.isRequired,
  toggleBanner: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

DownloadModal.defaultProps = {
  type: REPORT_TYPE_ORDER
};

const mapStateToProps = state => ({
  downloadForm: state.form.downloadForm,
  options: options(state),
  showBanner: showBanner(state),
  disabled: disabled(state)
});

const connector = connect(mapStateToProps, {
  addDownloadOption,
  removeDownloadOption,
  toggleBanner
});

export default reduxForm({
  form: 'downloadForm'
})(connector(DownloadModal));
